export const getFormData = state => state.form.data;
export const getFormPages = state => state.form.pages;
export const getSubmission = state => state.form.submission;
export const getReviewPageOpenChapters = state => state.form.reviewPageView.openChapters;
export const getViewedPages = state => state.form.reviewPageView.viewedPages;
